import { isEmpty, property } from 'lodash'

const getGqlMessage = property('graphQLErrors[0].message')

export default function getErrorMessage(error) {
    return isEmpty(error?.graphQLErrors)
        ? error?.message
        : getGqlMessage(error) || error?.message
}
